import React, { Component } from 'react';
import { toast } from "react-toastify";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import ArrowBackOutlinedIcon from '@material-ui/icons/ArrowBackOutlined';
import ArrowForwardOutlinedIcon from '@material-ui/icons/ArrowForwardOutlined';
import axios from '../../../../axios';
import apiError from '../../../../error';
import Spinner from '../../../spinner/spinner';

export default class TemplatesWhatsApp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            brodcastName: '',
            templateName: '',
            loading: false,
            replaceCount: {
                1: true
            },
            data: {
                1: {
                    name: '',
                    value: '',
                    key: ''
                }
            },
            gateWay: this.props.whatsappGateway,
            html: '',
            image: null,
            savedThumbnail: null,
        }
    }
    componentDidMount() {
        this.loadSender();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.whatsappGateway !== this.props.whatsappGateway) {
            this.setState({gateWay: this.props.whatsappGateway});
        }
        if (prevProps.senderId !== this.props.senderId) {
            this.loadSender();
        }
        if (prevProps.templateId !== this.props.templateId && this.props.templateId) {
            this.load();
        }
        if (prevState.gateWay !== this.state.gateWay && this.state.gateWay === 'Interakt') {
            this.setState({data: {1: {name: 'languageCode', value: '', key: ''}}});
        }
    }

    loadSender = () => {
        if (this.props.senderId) {
            axios.get('/api/senders/' + this.props.senderId, {})
                .then(res => {
                    if (res.data.sender) {
                        this.setState({
                            gateWay: res.data.sender?.whatsapp_gateway?.name ?? null,
                        }, () => {
                            this.load();
                        })
                    }else {
                        this.load();
                    }
                })
                .catch(error => apiError(error))
        } else {
            this.load();
        }
    }

    load = () => {
        if (this.props.templateId) {
            axios.get('/api/whatsapp-template/' + this.props.templateId, {})
                .then(res => {
                    let template = res.data.template
                    if (template) {
                        this.setState({
                            html: template.html,
                            brodcastName: template.brodcastName,
                            templateName: template.templateName,
                            savedThumbnail: template.whatsappMessageThumbnail || '',
                        })
                        if (template.whatsapp_templates) {
                            let data = {}, replaceCount = {};
                            if (this.state.gateWay==="Interakt" && template.whatsapp_templates.some(t => t.name === 'languageCode')) {
                                const index = template.whatsapp_templates.findIndex(t => t.name === 'languageCode');
                                const [languageCodeTemplate] = template.whatsapp_templates.splice(index, 1);
                                template.whatsapp_templates.unshift(languageCodeTemplate);
                            }
                            for (let i = 0; i < template.whatsapp_templates.length; i++) {
                                data[i + 1] = {
                                    name: template.whatsapp_templates[i].name,
                                    value: template.whatsapp_templates[i].value,
                                    key: template.whatsapp_templates[i]?.key ?? ''
                                }
                                replaceCount[i + 1] = true;
                            }
                            this.setState({ data, replaceCount })
                        }
                    }
                })
                .catch(err => {
                    apiError(err)
                })
        }
    }

    handleCreateTemplate = () => {
        if(this.state.gateWay === 'UYON'){
            if (!this.state.html || this.state.html.length === 0) {
                toast.error('Please enter Template Message');
                return;
            }
            const data = {
                data: [],
                brodcastName: null,
                templateName: 'UYON',
                html: this.state.html, 
                campaignTemplateId: this.props.campaignTemplateId
            }
            this.setState({ loading: true })
            if (this.props.templateId) {
                axios.patch('/api/whatsapp-template/' + this.props.templateId, data)
                    .then(res => {
                        this.setState({ loading: false })
                        this.props.handleTabChange('next');
                        toast.success('SMS template updated successfully')
                    })
                    .catch(error => {
                        apiError(error);
                        this.setState({ loading: false });
                    })
            } else {
                axios.post('/api/whatsapp-template/', data)
                    .then(res => {
                        this.setState({ loading: false });
                        this.props.handleTabChange('next');
                        this.props.handleTemplateId(res.data.template.id);
                        toast.success('SMS template created successfully')
                    })
                    .catch(error => {
                        apiError(error);
                        this.setState({ loading: false });
                    })
            }
        } else {
            if (!this.state.templateName || this.state.templateName.length === 0) {
                toast.error('Please enter Template Name');
                return;
            }
            if (this.state.gateWay !== "Interakt" && (!this.state.brodcastName || this.state.brodcastName.length === 0)) {
                toast.error('Please enter Brodcast Name');
                return;
            }
            const data = {
                data: [],
                brodcastName: this.state.brodcastName,
                templateName: this.state.templateName,
                campaignTemplateId: this.props.campaignTemplateId
            }
            Object.keys(this.state.replaceCount).forEach((key, index) => {
                if (this.state.replaceCount[key]) {
                    data['data'].push(this.state.data[key])
                }
            })
            this.setState({ loading: true })
            if (this.props.templateId) {
                axios.patch('/api/whatsapp-template/' + this.props.templateId, data)
                    .then(async res => {
                        this.setState({ loading: false })
                        this.props.handleTabChange('next');
                        if(this.state.gateWay === "Interakt") await this.handleUpdateBanner();
                        toast.success('SMS template updated successfully')
                    })
                    .catch(error => {
                        apiError(error);
                        this.setState({ loading: false });
                    })
            } else {
                axios.post('/api/whatsapp-template/', data)
                    .then(async res => {
                        this.setState({ loading: false });
                        this.props.handleTabChange('next');
                        this.props.handleTemplateId(res.data.template.id);
                        if(this.state.gateWay === "Interakt") await this.handleUpdateBanner();
                        toast.success('SMS template created successfully')
                    })
                    .catch(error => {
                        apiError(error);
                        this.setState({ loading: false });
                    })
            }
        }
    }

    addRow = () => {
        this.setState({
            replaceCount: { ...this.state.replaceCount, [Object.keys(this.state.replaceCount).length + 1]: true },
            data: { ...this.state.data, [Object.keys(this.state.replaceCount).length + 1]: { name: '', value: '' } }
        })
    }

    deleteRow = (count) => {
        this.setState({
            replaceCount: { ...this.state.replaceCount, [count]: false }
        })
    }
    handleImageChange = (e) => {
        this.setState({ savedThumbnail: '', image: e.target.files[0] });
    };
    handleUpdateBanner = async () => {
        if (!this.state.image) {
            return;
        }
        const formData = new FormData();
        formData.append('image', this.state.image);

        this.setState({ loading: true });
        try {
            await axios.post(`/api/whatsapp-template/update-banner/${this.props.templateId}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            this.setState({ loading: false });
        } catch (error) {
            apiError(error);
            this.setState({ loading: false });
        }
    };

    render() {
        return (
            <>
                <div className="email-template-wrap">
                    <div className='rightSectionHeader'>
                        <div className="row justify-content-between d-flex align-items-center mb-3">
                            <div className="col-md-6">
                                <h6 className="tab-head">Create SMS Template</h6>
                            </div>
                        </div>
                    </div>
                    {this.state.gateWay === 'UYON' ?
                        <Form.Group>
                            <Form.Label>WhatsApp Message</Form.Label>
                            <Form.Control as="textarea" rows={4} placeholder="please enter message body" value={this.state.html} onChange={e => this.setState({html: e.target.value})} />
                        </Form.Group>:
                        <Form.Group controlId="exampleForm.ControlTextarea1">
                            <div className='row'>
                                <div className='col-md-6'>
                                    <Form.Label>{this.state.gateWay === 'Qontak' ? 'Qontak Template ID' : 'Template Name'}</Form.Label>
                                    <Form.Control value={this.state.templateName} onChange={e => this.setState({ templateName: e.target.value })} />
                                </div>
                                {this.state.gateWay !== 'Yellow.ai' && this.state.gateWay !== 'Interakt' ?
                                    <div className='col-md-6'>
                                        <Form.Label>{this.state.gateWay === 'Qontak' ? 'Qontak Channel ID' : 'Brodcast Name'}</Form.Label>
                                        <Form.Control value={this.state.brodcastName} onChange={e => this.setState({ brodcastName: e.target.value })} />
                                    </div> : ''
                                }
                            </div>
                            <div className='attackCard  mt-3'>
                                <div className='midCard'>
                                    <Form.Label style={{ cursor: 'pointer' }}>Custom Params <AddIcon className="btn-icon" style={{ color: 'blue' }} onClick={this.addRow}></AddIcon></Form.Label>
                                    {Object.keys(this.state.replaceCount).map(((key, index) => {
                                        if (this.state.replaceCount[key]) {
                                            return (
                                                <div className='row' key={index}>
                                                    <div className='col-md-3'>
                                                        <label>{this.state.gateWay === 'Qontak' ? 'Value:' : 'Name:'}</label>
                                                        <Form.Control
                                                            value={this.state.data[key].name}
                                                            disabled={this.state.gateWay === 'Interakt' && key === '1' && this.state.data[key].name === 'languageCode'}
                                                            onChange={e =>
                                                                this.setState({
                                                                    data: {
                                                                        ...this.state.data,
                                                                        [key]: {
                                                                            name: e.target.value,
                                                                            /* remain will be same */
                                                                            value: this.state.data[key].value,
                                                                            key: this.state.data[key].key,
                                                                        }
                                                                    }
                                                                }
                                                                )}
                                                        />
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <label>{this.state.gateWay === 'Qontak' ? 'Value Text:' : ((this.state.gateWay === 'Interakt' && this.state.data[key].name !== 'languageCode' && key!==1) ?"Values (comma separated):":'Value:')}</label>
                                                        <Form.Control
                                                            value={this.state.data[key].value}
                                                            onChange={e =>
                                                                this.setState({
                                                                    data: {
                                                                        ...this.state.data,
                                                                        [key]: {
                                                                            value: e.target.value,
                                                                            /* remain will be same */
                                                                            name: this.state.data[key].name,
                                                                            key: this.state.data[key].key,
                                                                        }
                                                                    }
                                                                }
                                                                )}
                                                        />
                                                    </div>
                                                    {this.state.gateWay === 'Qontak' ?
                                                        <div className='col-md-4'>
                                                            <label>Key: </label>
                                                            <Form.Control
                                                                value={this.state.data[key].key}
                                                                onChange={e =>
                                                                    this.setState({
                                                                        data: {
                                                                            ...this.state.data,
                                                                            [key]: {
                                                                                key: e.target.value,
                                                                                /* remain will be same */
                                                                                value: this.state.data[key].value,
                                                                                name: this.state.data[key].name,
                                                                            }
                                                                        }
                                                                    }
                                                                    )}
                                                            />
                                                        </div> : ''
                                                    }
                                                    {!(this.state.gateWay ==='Interakt' && key === 1 && this.state.data[key].name === 'languageCode' )&& 
                                                        <div className='col-md-1 mt-2'>
                                                            <label></label>
                                                            <DeleteIcon className="btn-icon" style={{ color: 'red', cursor: 'pointer' }} onClick={e => this.deleteRow(key)}></DeleteIcon>
                                                        </div>
                                                    }
                                                </div>
                                            )
                                        } return null;
                                    }))}
                                </div>
                                {this.state.gateWay === "Interakt" && 
                                    <div className='telegramMessageSection'>
                                        <div className="url-wrapper variablesSection">
                                            <div class="contHeading">
                                                <h6>Custom Params Example</h6>
                                            </div>
                                            <div className="variableBox">
                                                <div className="badgeInfo">
                                                    <span className="label">bodyValues: &nbsp;</span>
                                                    <span className="token">&#123;&#123;.fname&#125;&#125; </span>, &nbsp;<span className="token">&#123;&#123;.lname&#125;&#125; </span>
                                                </div>
                                                <div className="badgeInfo">
                                                    <span className="label">buttonValues: &nbsp;</span>
                                                    <span className="token">&#123;&#123;.url&#125;&#125; </span> , &nbsp;<span className="token">btn_var_2 </span> 
                                                </div>
                                                <div className="badgeInfo">
                                                    <span className="label">buttonPayload: &nbsp;</span>
                                                    <span className="token">payload_for_quick_reply_0 </span>, &nbsp;<span className="token">payload_for_quick_reply_1</span> 
                                                </div>
                                            </div>

                                            <div className="badgeInfo mb-3">
                                                <span className="label">languageCode: &nbsp;</span>
                                                <span className="token">en</span>
                                            </div>

                                            <Form.Group >
                                                <Form.Label>Upload Image</Form.Label>
                                                <Form.File
                                                    className="form-control"
                                                    id="exampleFormControlFile1"
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={this.handleImageChange}
                                                    style={{ width: '45%' }}
                                                />
                                                {(this.state.image || this.state.savedThumbnail) && (
                                                    <img
                                                        src={this.state.savedThumbnail || URL.createObjectURL(this.state.image)}
                                                        alt="Preview"
                                                        className="img-fluid mt-2"
                                                        style={{ maxHeight: 150 }}
                                                    />
                                                )}
                                            </Form.Group>

                                        </div>

                                    </div>
                                }
                            </div>
                        </Form.Group>
                    }
                </div>
                <div className="mt-2">
                    <div className='footer-wrapper justify-content-end d-flex'>
                        <Button className="closeBtn mr-2" onClick={e => this.props.handleTabChange('prev')}><ArrowBackOutlinedIcon className="btn-icon"></ArrowBackOutlinedIcon> Previous</Button>
                        <Button variant="success" disabled={this.state.loading} type="button" onClick={this.handleCreateTemplate}><Spinner loading={this.state.loading}></Spinner><ArrowForwardOutlinedIcon className={this.state.loading ? "btn-icon d-none" : "btn-icon"}></ArrowForwardOutlinedIcon> Go To Next</Button>
                    </div>
                </div>
            </>
        )
    }
}
